import { render, staticRenderFns } from "./GetConnected.vue?vue&type=template&id=55bc61ea&"
import script from "./GetConnected.vue?vue&type=script&lang=js&"
export * from "./GetConnected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports